var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLinkedbig = function SvgLinkedbig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.162 0C21.177 0 22 .822 22 1.838v18.324A1.838 1.838 0 0120.162 22H1.838A1.838 1.838 0 010 20.162V1.838C0 .823.822 0 1.838 0h18.324zm-5.291 8.25c-1.55 0-2.614.68-3.095 1.474l-.088.16V8.387h-2.98V18.93h3.209v-5.106c0-1.712.63-2.8 2.145-2.8 1.034 0 1.474.906 1.518 2.524l.003.276v5.106h3.209v-5.822c0-3.144-.752-4.857-3.921-4.857zm-8.454 0H3.208v10.542h3.209V8.25zm-1.604-5.5a2.063 2.063 0 100 4.125 2.063 2.063 0 000-4.125z",
    fill: "#C4C4C4"
  })));
};
export default SvgLinkedbig;